import { Controller } from '@hotwired/stimulus';
import Choices from 'choices.js';

// Connects to data-controller="choice-select"
export default class extends Controller {
  static targets = ['select'];

  static values = {
    placeholder: String,
    searchEnabled: Boolean,
  }

  connect() {
    this.selectTargets.forEach((select) => {
      const choices = new Choices(select, {
        removeItemButton: false,
        searchEnabled: this.searchEnabledValue,
        placeholderValue: this.placeholderValue,
        noResultsText: 'No results found',
        placeholder: true,
        shouldSort: false,
        searchPlaceholderValue: 'Search by typing...',
        itemSelectText: '',
        position: 'bottom',
      });
    });
  }
}
